<template>
  <div
    :class="{
      'bg-blue-600 text-white px-4 py-2 min-w-max h-12 w-10 m-auto rounded-lg rounded-b-xl text-xs leading-8 mt-[-8px] font-medium absolute z-20 inset-x-[40%] flex justify-center gap-4':
        props.message,
      'bg-blue-600 text-white px-2 pt-0 w-fit h-7 m-auto rounded-lg text-xs leading-7 mt-[-8px] font-medium absolute z-20 right-[40%] inset- flex justify-center gap-4':
        !props.message,
    }"
  >
    <span class="w-2 h-2 absolute left-[-8px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
      >
        <path
          d="M8 8C8 3.58177 4.41827 2.83708e-07 -3.49691e-07 4.76837e-07L8 1.27146e-07L8 8Z"
          :fill="!props.message ? '#2563EB' : '#1e293b'"
        />
      </svg>
    </span>
    <span v-if="!props.message" class="initials m-auto">
      {{ getInitialsImpersonator() }}
    </span>
    <span v-if="!props.message">
      {{
        $t('top_panel.impersonate_banner', {
          name: `${userStore.user?.impersonated_by?.first_name} ${userStore.user?.impersonated_by?.last_name}`,
        })
      }}
    </span>
    <div class="inline-flex" v-if="props.message">
      <img
        src="@/assets/icons/vault_icon.svg"
        width="30px"
        height="30px"
        alt="sheild"
        class="mr-2"
      />
      {{ props.message }}
    </div>

    <q-btn
      v-if="!props.message"
      @click="handleStopImpersonate"
      outline
      size="8px"
      class="leading-1 h-2 pt-[2px] mt-[3px]"
      :label="$t('top_panel.stop')"
    />
    <span class="w-2 h-2 absolute right-[-8px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
      >
        <path
          d="M8 -9.53674e-07C3.58177 -5.6742e-07 9.05795e-08 3.58173 4.76837e-07 8L-2.22545e-07 -2.54292e-07L8 -9.53674e-07Z"
          :fill="!props.message ? '#2563EB' : '#1e293b'"
        />
      </svg>
    </span>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from 'src/core/stores/user';

const props = defineProps<{
  message?: string;
}>();
const userStore = useUserStore();
async function handleStopImpersonate() {
  await userStore.signOut();
}
function getInitialsImpersonator() {
  const firstNameInitial =
    userStore.user?.impersonated_by?.first_name[0]?.toUpperCase();
  const lastNameInitial =
    userStore.user?.impersonated_by?.last_name[0]?.toUpperCase();

  return `${firstNameInitial}${lastNameInitial}`;
}
</script>
<style lang="scss" scoped>
.initials {
  @apply block w-[19px] h-[19px] text-small mt-1 rounded-full bg-slate-300  text-slate-400 font-semibold text-center leading-[19px];
}
.svg-container {
  display: flex;
  align-items: center;
}
</style>
